<template>
  <div>
    <h1 class="title">PANTALLA {{ numeroPantalla }} GENERADOR</h1>

    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="GENERADOR" width="100%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="table1">
            <v-simple-table class="table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-heading" colspan="4">TENSION</th>
                    <th class="text-heading" colspan="2">INTENSIDAD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="label">L1</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL1) }}
                    </td>
                    <td class="label">L1-L3</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL1L3) }}
                    </td>
                    <td class="label">L1</td>
                    <td class="value gray">
                      {{ formatoIntensidad(intensidadL1) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="label">L2</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL2) }}
                    </td>
                    <td class="label">L2-L3</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL2L3) }}
                    </td>
                    <td class="label">L2</td>
                    <td class="value gray">
                      {{ formatoIntensidad(intensidadL2) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="label">L3</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL3) }}
                    </td>
                    <td class="label">L3-L1</td>
                    <td class="value gray">
                      {{ formatoTension(tensionL3L1) }}
                    </td>
                    <td class="label">L3</td>
                    <td class="value gray">
                      {{ formatoIntensidad(intensidadL3) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="table2">
            <v-simple-table class="table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-heading" colspan="2">TEMPERATURAS</th>
                    <th class="text-heading" colspan="1">KW. ACT.</th>
                    <th class="text-heading" colspan="1">KW. REACT.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="label2">COJINETE EXT.</td>
                    <td class="value gray">
                      {{ formatoTemperatura(temperaturaCojineteExterior) }}
                      Gr.
                    </td>
                    <td class="value gray">
                      {{ formatoKW(kwActualesActivos) }}
                    </td>
                    <td class="value gray">
                      {{ formatoKW(kwReactivos) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="label2">COJINETE INT.</td>
                    <td class="value gray">
                      {{ formatoTemperatura(temperaturaCojineteInterior) }}
                      Gr.
                    </td>
                    <td class="value yellow">
                      {{ formatoCoseno(cosenoDeFi) }}
                      Cos.
                    </td>
                    <td class="value cyann">APERTURA PALAS</td>
                  </tr>
                  <tr>
                    <td class="label2">PALIER TURBINA</td>
                    <td class="value gray">
                      {{ formatoTemperatura(temperaturaPalierTurbina) }}
                      Gr.
                    </td>
                    <td class="value yellow">{{ formatoHZ(herzios) }} Hz</td>
                    <td class="value purple">
                      {{ formatoApertura(aperturaPlacas) }}%
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="buttons">
            <HmiButton label="CUADRO" color="silver" width="33%" height="100%" :size="1.7"
              @click.native="navigateToGeneradorDatosCuadro"></HmiButton>
            <HmiButton label="MAS DATOS" color="silver" width="33%" height="100%" :size="1.7"
              @click.native="navigateToGeneradorMasDatos"></HmiButton>
            <HmiButton label="SALIR" color="silver" width="33%" height="100%" :size="1.7" @click.native="navigateToMenu">
            </HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "../HMI/HmiPantalla.vue";
export default {
  name: "MenuPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },

    direccionVariables() {
      if (this.numeroPantalla == 1) {
        return {
          TENSION_L1_LECTURA: 65, // Correspondiente a Dm1003
          TENSION_L2_LECTURA: 66, // Correspondiente a Dm1015
          TENSION_L3_LECTURA: 67, // Correspondiente a Dm1027
          TENSION_L1_L3_LECTURA: 71, // Correspondiente a Dm1055
          TENSION_L2_L3_LECTURA: 72, // Correspondiente a Dm1057
          TENSION_L3_L1_LECTURA: 73, // Correspondiente a Dm1059
          INTENSIDAD_L1_LECTURA_1: 75, // Correspondiente a Dm1105
          INTENSIDAD_L1_LECTURA_2: 76, // Correspondiente a Dm1105
          INTENSIDAD_L2_LECTURA_1: 77, // Correspondiente a Dm1117
          INTENSIDAD_L2_LECTURA_2: 78, // Correspondiente a Dm1117
          INTENSIDAD_L3_LECTURA_1: 79, // Correspondiente a Dm1129
          INTENSIDAD_L3_LECTURA_2: 80, // Correspondiente a Dm1129
          TEMPERATURA_COJINETE_EXTERIOR_LECTURA: 42, // Correspondiente a Dm94
          TEMPERATURA_COJINETE_INTERIOR_LECTURA: 41, // Correspondiente a Dm93
          TEMPERATURA_PALIER_TURBINA_LECTURA: 42, // Correspondiente a Dm94
          KW_ACTUALES_ACTIVOS_LECTURA_1: 81, // Correspondiente a Dm1143
          KW_ACTUALES_ACTIVOS_LECTURA_2: 82, // Correspondiente a Dm1143
          COSENO_DE_FI_LECTURA: 69, // Correspondiente a Dm1049
          HERZIOS_LECTURA: 70, // Correspondiente to Dm1051
          KW_REACTIVOS_LECTURA_1: 68, // Correspondiente a Dm1047
          KW_REACTIVOS_LECTURA_2: 70, // Correspondiente a Dm1047
          APERTURA_PLACAS_LECTURA: 38, // Correspondiente a Dm86
        };
      } else {
        return {
          TENSION_L1_LECTURA: 86, // Correspondiente a Dm1203
          TENSION_L2_LECTURA: 87, // Correspondiente a Dm1215
          TENSION_L3_LECTURA: 88, // Correspondiente a Dm1227
          TENSION_L1_L3_LECTURA: 91, // Correspondiente a Dm1255
          TENSION_L2_L3_LECTURA: 92, // Correspondiente a Dm1257
          TENSION_L3_L1_LECTURA: 93, // Correspondiente a Dm1259
          INTENSIDAD_L1_LECTURA_1: 94, // Correspondiente a Dm1305
          INTENSIDAD_L1_LECTURA_2: 95, // Correspondiente a Dm1305
          INTENSIDAD_L2_LECTURA_1: 96, // Correspondiente a Dm1317
          INTENSIDAD_L2_LECTURA_2: 97, // Correspondiente a Dm1317
          INTENSIDAD_L3_LECTURA_1: 98, // Correspondiente a Dm1329
          INTENSIDAD_L3_LECTURA_2: 99, // Correspondiente a Dm1329
          TEMPERATURA_COJINETE_EXTERIOR_LECTURA: 45, // Correspondiente a Dm97
          TEMPERATURA_COJINETE_INTERIOR_LECTURA: 44, // Correspondiente a Dm96
          TEMPERATURA_PALIER_TURBINA_LECTURA: 43, // Correspondiente a Dm95
          KW_ACTUALES_ACTIVOS_LECTURA_1: 100, // Correspondiente a Dm1343
          KW_ACTUALES_ACTIVOS_LECTURA_2: 101, // Correspondiente a Dm1343
          COSENO_DE_FI_LECTURA: 89, // Correspondiente a Dm1249
          HERZIOS_LECTURA: 90, // Correspondiente to Dm1251
          KW_REACTIVOS_LECTURA_1: 102, // Correspondiente a Dm1347
          KW_REACTIVOS_LECTURA_2: 103, // Correspondiente a Dm1347
          APERTURA_PLACAS_LECTURA: 39, // Correspondiente a Dm88
        };
      }
    },

    tensionL1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L1_LECTURA
        ];
      }
      return "0000";
    },

    tensionL2() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L2_LECTURA
        ];
      }
      return "0000";
    },

    tensionL3() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L3_LECTURA
        ];
      }
      return "0000";
    },

    tensionL1L3() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L1_L3_LECTURA
        ];
      }
      return "0000";
    },

    tensionL2L3() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L2_L3_LECTURA
        ];
      }
      return "0000";
    },

    tensionL3L1() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TENSION_L3_L1_LECTURA
        ];
      }
      return "0000";
    },

    intensidadL1() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L1_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L1_LECTURA_1
          ]
        );
      }
      return "00000000";
    },

    intensidadL2() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L2_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L2_LECTURA_1
          ]
        );
      }
      return "00000000";
    },

    intensidadL3() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L3_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.INTENSIDAD_L3_LECTURA_1
          ]
        );
      }
      return "00000000";
    },

    temperaturaCojineteExterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMPERATURA_COJINETE_EXTERIOR_LECTURA
        ];
      }
      return "0000";
    },

    temperaturaCojineteInterior() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMPERATURA_COJINETE_INTERIOR_LECTURA
        ];
      }
      return "0000";
    },

    temperaturaPalierTurbina() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TEMPERATURA_PALIER_TURBINA_LECTURA
        ];
      }
      return "0000";
    },

    kwActualesActivos() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.KW_ACTUALES_ACTIVOS_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.KW_ACTUALES_ACTIVOS_LECTURA_1
          ]
        );
      }
      return "00000000";
    },

    cosenoDeFi() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.COSENO_DE_FI_LECTURA
        ];
      }
      return "0000";
    },

    herzios() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.HERZIOS_LECTURA
        ];
      }
      return "0000";
    },

    kwReactivos() {
      if (this.direccionVariables) {
        return (
          this.$store.state.lecturas[
          this.direccionVariables.KW_REACTIVOS_LECTURA_2
          ] +
          this.$store.state.lecturas[
          this.direccionVariables.KW_REACTIVOS_LECTURA_1
          ]
        );
      }
      return "00000000";
    },

    aperturaPlacas() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.APERTURA_PLACAS_LECTURA
        ];
      }
      return "0000";
    },

  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Navegación a "Mas datos"
    navigateToGeneradorMasDatos() {
      this.$router.push(`/pantalla/${this.numeroPantalla}/generador/masdatos`);
    },

    // Navegación a "Datos cuadro"
    navigateToGeneradorDatosCuadro() {
      this.$router.push(
        `/pantalla/${this.numeroPantalla}/generador/datoscuadro`
      );
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "1", this.numeroPantalla);
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "1", this.numeroPantalla);
    },

    formatoIntensidad(dato) {
      return dato.substring(2, 5);
    },

    formatoTension(dato) {
      let dec = parseInt(dato, 16).toString();
      dec = dec.slice(-3);
      return dec.padStart(3, "0"); //Añadir ceros
    },

    formatoTemperatura(dato) {
      const signo = dato.substring(0, 1);
      dato = dato.substring(1, 4);
      if (signo == "F") {
        return "-" + dato;
      } else {
        return dato;
      }
    },

    formatoKW(dato) {
      return dato.substring(2, 5);
    },

    formatoCoseno(dato) {
      dato = parseInt(dato, 16);
      if ((dato & 0x8000) > 0) {
        dato = dato - 0x10000;
      }

      return dato;
    },

    formatoHZ(dato) {
      let dec = parseInt(dato, 16).toString();
      return dec.substring(0, 2) + "." + dec.substring(2, 4);
    },

    formatoApertura(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  padding-top: 20px;
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.table {
  background-color: transparent;
  width: 100%;
  overflow-y: auto;
  font-size: 2vw !important;
}

.buttons {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  height: 15%;
}

.table1 {
  height: 40%;
}

.table2 {
  height: 40%;
}

.text-heading {
  background-color: cyan;
  border: solid 1px;
  text-align: center !important;
}

.label {
  background-color: #87c0ff;
  width: 70px;
  border: solid 1px;
}

.label2 {
  background-color: cyan;
  width: 150px;
  border: solid 1px;
}

.gray {
  background-color: silver;
}

.yellow {
  background-color: #c0c000 !important;
}

.cyann {
  background-color: cyan !important;
}

.purple {
  background-color: #ff00c0 !important;
}

.value {
  border: solid 1px !important;
}

th {
  font-size: min(2vw, 20px) !important;
  height: fit-content !important;
  width: fit-content !important;
}

td {
  padding: 0 !important;
  text-align: center;
  font-size: clamp(10px, 1.3vw, 21px) !important;
  height: clamp(20px, 5vw, 60px) !important;
  width: fit-content !important;
}
</style>
